import { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/bulk-sms`;
export const FIELDS = ['{{FIRST_NAME}}', '{{LAST_NAME}}', '{{FULL_NAME}}', '{{BROKER_NAME}}'];
export const OPT_OUT_LINE = 'Reply STOP to opt out';
const GSM = new Set("@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^{}\\[~]|€");

export const segments = (t) => { const gsm = [...t].every((c) => GSM.has(c)); const n = t.length; return gsm ? (n <= 160 ? 1 : Math.ceil(n / 153)) : (n <= 70 ? 1 : Math.ceil(n / 67)); };
export const isGsm = (t) => [...t].every((c) => GSM.has(c));
export const render = (body, r, marketing) => {
  const first = (r?.first_name || '').trim() || 'there';
  let out = body.replaceAll('{{FIRST_NAME}}', first).replaceAll('{{LAST_NAME}}', r?.last_name || '').replaceAll('{{FULL_NAME}}', r?.name || first).replaceAll('{{BROKER_NAME}}', r?.broker || '');
  if (marketing && !out.toLowerCase().includes('stop')) out = `${out.trimEnd()}\n${OPT_OUT_LINE}`;
  return out;
};
export const money = (n) => `$${(n || 0).toFixed(2)}`;
export const errMsg = (e, d = 'Something went wrong') => { const x = e?.response?.data?.detail; return (x && typeof x === 'object' ? x.message : x) || d; };

export const useBulkSms = () => {
  const { token } = useAuth();
  const headers = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);
  const [overview, setOverview] = useState(null);
  const [templates, setTemplates] = useState([]);
  const loadOverview = useCallback(() => axios.get(`${API}/overview`, headers).then(({ data }) => setOverview(data)).catch(() => setOverview({ error: true })), [headers]);
  const loadTemplates = useCallback(() => axios.get(`${API}/templates`, headers).then(({ data }) => setTemplates(data.templates || [])).catch(() => {}), [headers]);
  useEffect(() => { loadOverview(); loadTemplates(); }, [loadOverview, loadTemplates]);
  return { headers, overview, loadOverview, templates, loadTemplates };
};
